export default __webpack_public_path__ + "locales/uk-UA/Settings.json?hash=8c8383b93e590b0c60bba75319ac00c4";